<template lang="pug">
  b-navbar(toggleable='lg')
    b-navbar-brand.d-md-none(:to="{name:'home'}")
      img.nav-brand-img(src="@/assets/images/branding/logo_dark.svg")
    b-navbar-toggle.m-3(target='nav_collapse', style="border: none;")
    b-collapse#nav_collapse.p-2(is-nav='', v-model="navCollapse")
      b-navbar-nav.nav-1.nav-segment
            b-nav-item#btnArt(:to="{name: 'gallery'}") ART
            b-nav-item(:to="{name: 'artists'}") ARTISTS
            b-nav-item(:to="{ name: 'rentals' }") RENTALS
            b-nav-item(:to="{ name: 'CorporateRentals' }") CORPORATE
            //- b-nav-item(:to="{name: 'about'}") ABOUT US
      .nav-segment.text-center
        b-navbar-brand.d-none.d-md-block(:to="{name:'home'}", aria-label="Wall collective home page")
          img.nav-brand-img(src="@/assets/images/branding/logo_dark.svg", alt="Wall collective logo")
      b-navbar-nav.nav-2.nav-segment.justify-content-end(@click="navCollapse = false;")
          div.ml-md-auto(v-if="account.loggedIn")
            b-nav.d-flex.align-items-center
              b-nav-item#btnAccount(v-if="account.loggedIn", :to="{name:'AccountProfile'}")
                b-avatar(variant="dark", size="2rem", :text="`${account.user.firstname[0]}${account.user.lastname[0]}`")
              b-nav-item(:to="{name:'love'}")
                font-awesome-icon.favourite(icon="heart")
              b-nav-item#btnCart(:to="{name:'cart'}")
                font-awesome-icon(icon="shopping-cart", variant="text-danger", :class="{ favourite: cartCount > 0}")
                // b-badge(variant='dark', v-if='cartCount').ml-2 {{ cartCount }}
          b-navbar-nav.text-right(v-else="")
            b-nav-item#btnLogin(:to="{name:'login'}") LOGIN / REGISTER
            b-nav-item(:to="{name:'artist-register'}") ARTIST SIGN-UP
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'Navbar',
  mixins: [standardMix],
  data() {
    return {
      navCollapse: false,
    };
  },
  computed: {
    ...mapGetters('cart', ['cartCount']),
  },
  methods: {
    ...mapActions('account', ['logout']),
  },
};
</script>

<style lang="scss" scoped>
.nav-segment {
  flex-basis: 0;
  flex-grow: 1;
}
.navbar {
  .nav-item {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
    white-space: nowrap;
  }
  .nav-content {
    // border-bottom: 1px solid rgba(black, 0.3);
    display: flex;
    justify-content: space-between;
  }
  align-items: flex-end;
  .nav-link {
    // font-family: Belleza;
  }
  // border-bottom: 1px solid rgba(black, 0.3);
  // min-height: $navbar-height;
  // background-color: white;
  .navbar-collapse {
    // border-bottom: 1px solid rgba(black, 0.3);
    // background-color: white;
    &.show {
      .nav-1 {
        a {
          margin: 5px 0px 5px 0px;
          text-align: center;
          border: 1px solid rgba(black, 0.5);
        }
        ul {
          padding-top: 10px;
          padding-bottom: 10px;
        }
      }
      .nav-2 {
        ul {
          display: flex;
          justify-content: space-around;
          a {
            border-bottom: none
          }
        }
      }
    }
  }
}
  .nav-brand-img{
    height: 25px;
  }
  a{
    padding: 20px;
  }

  .navbar a{
    // font-size: 0.8rem;
    color: rgba(black, 0.8) !important;
    .favourite {
      color: darkgreen !important;
    }
  }
  // .b-nav-item-exact-active{
  //   border-bottom: 1px solid white;
  // }

  .navbar-brand {
    border-bottom: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/structure/Navbar.vue